import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "address--colorful",
  "use": "address--colorful-usage",
  "viewBox": "0 0 12.47 16.39",
  "content": "<symbol viewBox=\"0 0 12.47 16.39\" id=\"address--colorful\"><defs><linearGradient id=\"address--colorful_a\" x1=\"15.73\" y1=\"16.49\" x2=\"-1.83\" y2=\"-1.08\" gradientUnits=\"userSpaceOnUse\"><stop offset=\"0\" stop-color=\"#f06767\" /><stop offset=\"1\" stop-color=\"#f78a79\" /></linearGradient></defs><title>pin</title><path d=\"M6.24 16.39l-.33-.27C4.52 15 0 10.81 0 6.23a6.23 6.23 0 0 1 12.47 0c0 4.37-4.52 8.66-5.91 9.88zM6.24 1A5.24 5.24 0 0 0 1 6.23c0 3.84 3.65 7.46 5.22 8.84 1.57-1.43 5.25-5.17 5.25-8.84A5.24 5.24 0 0 0 6.24 1zm.15 8.21a2.5 2.5 0 1 1 2.5-2.5 2.5 2.5 0 0 1-2.5 2.5zm0-4a1.5 1.5 0 1 0 1.5 1.5 1.5 1.5 0 0 0-1.5-1.5z\" fill=\"url(#address--colorful_a)\" /></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id


//////////////////
// WEBPACK FOOTER
// ./application/components/dumb/icon/src/address--colorful.svg
// module id = 196
// module chunks = 0